import { wpApi, useWPApi, DeepQueryParams, parseUrl } from '@gik/core/api';
import { ResponsePromise } from 'ky';
import { ConfigInterface } from 'swr';
import WordpressSituation from '@gik/core/models/wordpress/WordpressSituation';
import { WordpressError } from '@gik/core/models/wordpress/WordpressError';

const PATH = 'situation';

export function getSituationsSearchParams(page: number, perPage: number): DeepQueryParams {
  return {
    _fields:
      'id,parent,link,name,slug,sample_page_url.count,acf.tax_thumb_image,acf.sample_inkind_page_url,acf.taxonomy_svg_icon,acf.taxonomy_svg_icon_alt,acf.create_flow_categories',
    page,
    per_page: perPage,
    filter: {
      orderby: 'meta_value_num',
      meta_key: 'situation_weighting',
      order: 'desc',
    },
  };
}

export function getSamplePageSituationsSearchParams(page: number, perPage: number): DeepQueryParams {
  const baseParams = getSituationsSearchParams(page, perPage);
  return {
    ...baseParams,
    filter: {
      ...(baseParams.filter as object),
      meta_query: {
        '0': {
          key: 'sample_inkind_page_url',
          compare: 'LIKE',
          value: 'giveinkind.com',
        },
      },
    },
  };
}

export default async function getInkindSituations(
  page = 1,
  perPage = 8,
  deepQueryParams = getSituationsSearchParams(page, perPage)
): Promise<WordpressSituation[]> {
  const finalUrl = parseUrl(PATH, {
    deepQueryParams,
  });
  const apiResponse: ResponsePromise = wpApi.get(finalUrl);
  return apiResponse.json<WordpressSituation[]>();
}

export function useInkindSituations(
  page = 1,
  perPage = 8,
  config?: ConfigInterface,
  deepQueryParams = getSituationsSearchParams(page, perPage)
) {
  return useWPApi<WordpressSituation[]>(PATH, config, {
    deepQueryParams,
  });
}
